export default "/fonts/vendor/tinymce/skins/lightgray/tinymce.svg?deb53e1c037600dd48352fe17962fc1e";